import { render, staticRenderFns } from "./FooterComponents.vue?vue&type=template&id=2b670215&scoped=true"
import script from "./FooterComponents.vue?vue&type=script&lang=js"
export * from "./FooterComponents.vue?vue&type=script&lang=js"
import style0 from "./FooterComponents.vue?vue&type=style&index=0&id=2b670215&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b670215",
  null
  
)

export default component.exports